<template>
  <BaseDialog
      title="按分対象選択"
      append-to-body
      width="40%"
      :visible.sync="dialogVisible"
      :show-only-close-button="showOnlyCloseButton"
      :disable-ok-button="false"
      @closed="closed"
      @cancel="cancel"
      @ok="save">
    <template slot="contents">
      <div v-show="showErrorMessage"
          style="display:block"
          class="is-error-msg">
        {{ errorMessage }}
      </div>
      <div class="dialog-contents">
        <template v-for="(shipment, i) in this.shipmentList">
          <div :key="i"
              class="shipment-row">
            <span>配送先{{ i + 1 }} (配送番号： {{ shipment.shipmentId }})</span>
            <BaseTableList
                :table-set-list="productList"
                :display-items="shipment.items"
                :editable="editable" />
          </div>
        </template>
      </div>
    </template>
  </BaseDialog>
</template>

<style scoped>
.no-data-message {
  margin: 5px 15px;
}
.dialog-contents {
  margin: 20px 20px;
}
.dialog-contents ::v-deep span {
  font-weight: bold;
  color: #9da6ba;
}
.shipment-row {
  margin-bottom: 40px;
}
</style>

<script>

import _ from 'lodash'
import * as define from '@/define'
import x from '@/components/mixins/mixin'
import orderUtil from '@/components/mixins/orderUtil'
import compare from '@/utils/compareUtils'

import { ELEMENT_TYPE } from '@/components/molecules/BaseCell'
import BaseTableList from '@/components/molecules/BaseTableList'
import BaseDialog from '@/components/molecules/BaseDialog'

export default {
  name: 'SlipDialog',
  components: {
    BaseTableList,
    BaseDialog
  },
  mixins: [x, orderUtil],
  props: {
    showOnlyCloseButton: {
      type: Boolean,
      default: true
    },
    visible: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Object,
      default: () => ({})
    },
    target: {
      type: Object,
      default: null
    },
    shipments: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      shipmentList: [],
      originShipmentList: [],
      dialogVisible: false,
      errorMessage: null
    }
  },
  computed: {
    showErrorMessage () {
      return this.errorMessage
    },
    define: () => define,
    // 一覧テーブル
    productList () {
      return [
        { label: 'No', path: 'position', type: 'String', width: 70 },
        { label: 'SKU', path: 'productId', type: 'String', width: 200 },
        { label: '商品名', path: 'productName', type: 'String' },
        { label: '金額', path: 'grossPrice', type: 'Number', width: 80 },
        {
          label: '対象', type: 'String', elementType: ELEMENT_TYPE.CHECK_BOX,
          path: 'isAdjustment', width: 80, editableId: 'isAdjustment', class: 'center'
        }
      ]
    }
  },
  watch: {
    visible (val) {
      this.dialogVisible = val
    },
    dialogVisible (val) {
      this.$emit('update:visible', val)
      if (val) {
        // 画面表示する際に、配送先から選択リストを作成
        this.shipmentList = this.getShipmentList()
        this.originShipmentList = _.cloneDeep(this.shipmentList)
      }
    }
  },
  created () {
  },
  methods: {
    getShipmentList () {
      let shipmentList = []
      // 配送先
      this.shipments.forEach(obj => {
        const shipment = {}
        shipment.shipmentId = obj.shipmentId
        let itemList = []
        // 注文明細
        obj.items.forEach(v => {
          // 注文明細は按分対象にあるかどうか
          const idx = this.target.priceAdjustmentItems.findIndex(e => {
            if (_.has(e, 'orderItemUuid') && e.orderItemUuid === v.uuid) {
              return e.delete === 0
            } else if (_.has(e, 'orderDetailItemsKey') && e.orderDetailItemsKey === v.orderDetailItemsKey) {
              return e.delete === 0
            } else if (_.has(e, 'item') && e.item.uuid === v.uuid) {
              return true
            }
            return false
          })

          const isAdjustment = idx >= 0 ? 1 : 0
          itemList.push({
            uuid: v.uuid, // 注文明細が新規の場合は値なし
            orderDetailItemsKey: v.orderDetailItemsKey, // 注文明細が新規の場合は値あり
            position: v.position,
            productId: v.productId,
            productName: v.productName,
            grossPrice: Number(v.price.gross) + v.priceAdjustments.reduce((sum, element) => sum + Number(element.price.gross), 0),
            isAdjustment: isAdjustment // 按分対象か
          })
        })
        shipment.items = itemList
        shipmentList.push(shipment)
      })
      return shipmentList
    },
    closed () {
      this.end()
    },
    cancel () {
      this.shipmentList = _.cloneDeep(this.originShipmentList)
      this.end()
    },
    end () {
      this.dialogVisible = false
      this.errorMessage = null
    },
    async save () {
      const hasError = this.validate()
      if (hasError) {
        return
      } else {
        this.errorMessage = null
      }
      const diffList = compare.diff(this.shipmentList, this.originShipmentList)
      for (const index in diffList) {
        const shipment = this.shipmentList[index]
        for (const itemIndex in _.get(diffList, index, {}).items) {
          const item = shipment.items[itemIndex]
          const idx = this.target.priceAdjustmentItems.findIndex(e => {
            if (_.has(e, 'item') && e.item.uuid === item.uuid) {
              return true
            }
            return false
          })

          if (item.isAdjustment === 1) {
            // ON時
            if (idx >= 0) {
              // priceAdjustmentItemsに対象の明細が存在する場合、以下を更新
              // ON==>OFF==>ON、変化なしので、OFFにした時追加された項目を除去。
              this.$delete(this.target.priceAdjustmentItems[idx], 'orderItemUuid')
              this.$delete(this.target.priceAdjustmentItems[idx], 'delete')
            } else {
              // priceAdjustmentItemsに対象の明細が存在しない場合、以下のオブジェクトを追加
              // 既存注文明細の場合uuid、新規注文明細の場合orderDetailItemsKey
              if (item.uuid) { // 既存注文明細の場合
                this.target.priceAdjustmentItems.push({
                  orderItemUuid: item.uuid,
                  delete: 0
                })
              } else { // 既存注文明細の場合
                this.target.priceAdjustmentItems.push({
                  orderDetailItemsKey: item.orderDetailItemsKey,
                  delete: 0
                })
              }
            }
          } else {
            // OFF時
            if (idx >= 0) {
              // 既存調整明細の場合、以下を更新
              _.set(this.target.priceAdjustmentItems[idx], 'orderItemUuid', item.uuid)
              _.set(this.target.priceAdjustmentItems[idx], 'delete', 1)
            } else {
              const empIdx = this.target.priceAdjustmentItems.findIndex(e => {
                if (e.orderItemUuid === item.uuid || e.orderDetailItemsKey === item.uuid) {
                  return true
                }
                return false
              })
              // priceAdjustmentItemsに対象の明細にidがない場合、対象のオブジェクトを削除
              this.$delete(this.target.priceAdjustmentItems, empIdx)
            }
          }
        }
      }
      this.end()
    },
    validate () {
      // 小計値引きの金額が0円ではない かつ 注文調整金額が既存データ
      if (_.has(this.target, 'id') && Number(this.target.price.gross) !== 0) {
        // 注文調整金額明細の既存データがある
        const idx = this.target.priceAdjustmentItems.findIndex((e) => _.has(e, 'id'))
        if (idx >= 0) {
          const selectIndex = this.shipmentList.findIndex((e) =>
            e.items.findIndex((v) => v.isAdjustment === 1) >= 0)
          if (selectIndex < 0) {
            // 商品が1つも選択されていない（エラーメッセージ：按分対象商品が選択されていません。）
            this.errorMessage = '按分対象商品が選択されていません。'
            return true
          }
        }
      }
      const zeroIndex = this.shipmentList.findIndex((e) =>
        e.items.findIndex((v) => v.isAdjustment === 1 && Number(v.grossPrice) === 0) >= 0)
      if (zeroIndex >= 0) {
        // 金額が0円の商品を按分対象としている（エラーメッセージ：金額のない商品のため按分対象にできません。）
        this.errorMessage = '金額のない商品のため按分対象にできません。'
        return true
      } else {
        // 選択された商品の単品値引き後の金額の和が小計値引きの金額以上であることをチェックする
        let selectedKey = []
        let selectedItemGrossPrice = 0
        for (const shipment of this.shipmentList) {
          for (const item of shipment.items.filter(e => e.isAdjustment)) {
            selectedKey.push(item.uuid || item.orderDetailItemsKey)
          }
        }
        for (const shipment of this.shipments) {
          for (const item of shipment.items) {
            if (selectedKey.includes(item.uuid || item.orderDetailItemsKey)) {
              selectedItemGrossPrice += Number(item.price.gross)
              for (const priceAdjustment of item.priceAdjustments) {
                selectedItemGrossPrice += Number(priceAdjustment.price.gross)
              }
            }
          }
        }
        if (selectedItemGrossPrice + Number(this.target.price.gross) < 0) {
          this.errorMessage = '按分対象商品の金額の和は値引金額より大きくしないといけません。'
          return true
        }
      }
    }
  }
}
</script>
